import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SoftwareManagementSettings = () => {
  return (
    <ResponsivePage.Body variant="wide" showHeader={false}>
      <ApprovalsBlock
        category="software"
        title={i18n.t('software_management.settings.approvals.title')}
        description={i18n.t('software_management.settings.approvals.description')}
      />
    </ResponsivePage.Body>
  )
}

export default SoftwareManagementSettings
